<template>
  <div class="body-width" >
    <div class="div-row div-pad-top news-Medium-24" >
      互联网+航海教育
    </div>
    <div class="div-row">
      <p class="indentation">互联网+航海教育平台借助先进的计算机网络和通讯技术，实时传递多元数据信息，为用户创造不受时间、空间限制的可视化交互学习环境。目前已开发的在线航海教育资源包括船舶配载、虚拟漫游、操纵与避碰、GMDSS等，跨平台多浏览器支持。</p>
    </div>
    <div class="div_img_body">
      <div class="row pad_top">
          <div>
            <img src="../../../../assets/images/productcenter/hlw/1.png">
            <div class="small_title news-Regular-14b6 ">
              内河船舶避碰与信号虚拟仿真实训平台
            </div>
          </div>
        <div class="pad_left">
          <img src="../../../../assets/images/productcenter/hlw/2.png">
          <div class="small_title news-Regular-14b6">
            内河船舶避碰与信号虚拟仿真实训平台
          </div>
        </div>
      </div>
      <div class="row pad_top">
        <div>
          <img src="../../../../assets/images/productcenter/hlw/3.png">
          <div class="small_title news-Regular-14b6">
            船舶虚拟漫游平台
          </div>
        </div>
        <div class="pad_left">
          <img src="../../../../assets/images/productcenter/hlw/4.png">
          <div class="small_title news-Regular-14b6">
            船舶虚拟漫游平台
          </div>
        </div>
      </div>
      <div class="row pad_top">
        <div>
          <img src="../../../../assets/images/productcenter/hlw/5.png">
          <div class="small_title news-Regular-14b6">
            船舶装载计算机系统
          </div>
        </div>
        <div class="pad_left">
          <img src="../../../../assets/images/productcenter/hlw/6.png">
          <div class="small_title news-Regular-14b6">
            GMDSS仿真实训平台
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "hlwhhjy"
}
</script>

<style scoped>
  .div-pad-top {
    padding-top: 50px;
    padding-bottom: 30px;
  }
  .div_img_body{
    padding-left: 35px;
  }
  .pad_left{
    padding-left: 65px;
  }
  .pad_top{
    padding-top: 30px;
  }
  .small_title news-Regular-14b6{
    padding-top: 10px;
  }
</style>



// WEBPACK FOOTER //
// src/components/contentcoms/prodecutcontentcoms/hlwxlcp/hlwhhjy.vue